var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-tour", {
        attrs: {
          name: "dyadeyTour",
          steps: _vm.steps,
          callbacks: _vm.callbacks,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }